// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3BgKI","validationTips":"StatementDescriptor_validationTips__3XNzh"};